import React from 'react';

import { useClassnames, visuallyHidden } from '@lumapps/classnames';
import { Heading } from '@lumapps/lumx/react';
import { useTranslate } from '@lumapps/translations';

import { LUMX_CHAT } from '../../keys';
import { ChatMessageBubble, ChatMessageBubbleProps } from '../ChatMessageBubble';

export type ChatMessageProps = ChatMessageBubbleProps;

const CLASSNAME = 'lumx-chat-message';

/**
 * Message component of a chat feature
 * Style is defined by the `type` prop.
 * @family Chat
 * @param ChatMessageProps
 * @returns ChatMessage
 */
export const ChatMessage: React.FC<ChatMessageProps> = ({ children, type = 'sent', className, ...forwardedProps }) => {
    const { block } = useClassnames(CLASSNAME);
    const { translateKey } = useTranslate();

    if (!children) {
        return null;
    }

    return (
        <ChatMessageBubble className={block(type, [className])} type={type} {...forwardedProps}>
            <Heading as="h3" className={visuallyHidden()}>
                {translateKey(type === 'sent' ? LUMX_CHAT.MESSAGE_SENT : LUMX_CHAT.MESSAGE_RECEIVED)}
            </Heading>
            {children}
        </ChatMessageBubble>
    );
};
